import createReactClass from 'create-react-class';
/* eslint-disable react/prop-types */
// -*- mode: jsx;-*-
// Defined in general.js
/* global dcAnalytics Uri */
import PureRenderMixin from '../common/external-adapters/pureRenderMixinAdapter.js';

const PickAProject = createReactClass({
    mixins: [PureRenderMixin],

    trackClick: function () {
        dcAnalytics.trackEventGA(['Search Page', 'Proposal Picker Clicked']);
        return true;
    },

    render: function () {
        const pickerURL = new Uri(baseURL + 'donors/proposal_picker.html')
            .setQuery(new Uri(this.props.searchURL).query())
            .replaceQueryParam('max', '25')
            .replaceQueryParam('page', '1');

        return (
            <a className="button-secondary small pick-project" rel="nofollow"
                href={pickerURL} onClick={this.trackClick}>
                Pick a project for me
            </a>
        );
    },
});

export default PickAProject;
